/**
 * Created by Stefano Mandruzzato on 20/11/18.
 */

import './external-layout.html';

const ExternalLayoutComponent = {
  bindings: {},
  template: require('./external-layout.html')
};


export default ExternalLayoutComponent;



// WEBPACK FOOTER //
// ./client/app/layout/external-layout/external-layout.component.js